import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const UpdateAddressInfo = ({ christian, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    district: '',
    sector: '',
    cell: '',
    village: '',
    isibo: ''
  });

  useEffect(() => {
    if (christian) {
      setFormData({
        district: christian.district || '',
        sector: christian.sector || '',
        cell: christian.cell || '',
        village: christian.village || '',
        isibo: christian.isibo || ''
      });
    }
  }, [christian]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE_URL}/christian/update/${christian.id}`, formData);  // CHANGE THIS LINE
      onUpdate();
    } catch (error) {
      console.error("Error updating address info:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.district}
          </label>
          <input
            type="text"
            name="district"
            value={formData.district}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.sector}
          </label>
          <input
            type="text"
            name="sector"
            value={formData.sector}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.cell}
          </label>
          <input
            type="text"
            name="cell"
            value={formData.cell}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.village}
          </label>
          <input
            type="text"
            name="village"
            value={formData.village}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.isibo}
          </label>
          <input
            type="text"
            name="isibo"
            value={formData.isibo}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default UpdateAddressInfo;